
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-card/oklahoma",
      function () {
        return require("private-next-pages/medical-card/oklahoma.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-card/oklahoma"])
      });
    }
  